import { Container, DefaultPageLayout } from 'routes/components/Layout'
import { LINKS } from 'routes/constants'
import { BreadcrumbsNavigation } from 'routes/components/Shared'
import { BestSupport } from 'routes/components/Features/BestSupport'
import {
  getSolutionsBreadcrumbs,
  PageType,
  SolutionsHeroType,
} from 'routes/Solutions/helpers'
import { SolutionHeadMetatag } from 'routes/Solutions/components/SolutionHeadMetatag'
import { SolutionHero } from 'routes/Solutions/components/SolutionHero'
import { SolutionHIL } from 'routes/Solutions/components/SolutionHIL'
import { SolutionHowItWorks } from 'routes/Solutions/components/SolutionHowItWorks'
import { SolutionCompanies } from 'routes/Solutions/components/SolutionCompanies'
import { SolutionInfrastructure } from 'routes/Solutions/components/SolutionInfrastructure'
import AppsGrid from '../components/SolutionHIL/components/AppsGrid'
import MonitorStatus from '../components/SolutionHIL/components/MonitorStatus'
import dataMigrationMob1x from './data-migration-mob@1x.avif'
import dataMigrationMob2x from './data-migration-mob@2x.avif'
import dataMigrationDesk1x from './data-migration-desk@1x.avif'
import dataMigrationDesk2x from './data-migration-desk@2x.avif'
import dataImport1x from 'routes/Solutions/components/SolutionHIL/components/DataImport/data-import@1x.avif'
import dataImport2x from 'routes/Solutions/components/SolutionHIL/components/DataImport/data-import@2x.avif'
import fieldMappings1x from 'routes/Solutions/components/SolutionHIL/components/FieldMappings/field-mappings@1x.avif'
import fieldMappings2x from 'routes/Solutions/components/SolutionHIL/components/FieldMappings/field-mappings@2x.avif'
import classes from '../solutions.module.scss'

export const pageData: PageType = {
  title: 'Migration from Other Apps',
  href: LINKS.SOLUTIONS.MIGRATION_FROM_OTHER_APPS,
  imageSrc: `${dataMigrationDesk1x.src}`,
  srcSet: `${dataMigrationDesk1x.src} 1x, ${dataMigrationDesk2x.src} 2x`,
  description: `Import all of your new customer's data from another application. Simplify migration and streamline onboarding experience.`,
}

const pageHeroData: SolutionsHeroType = {
  title: 'Data migration from another SaaS',
  subtitle:
    "Import all of your new customer's data from another application. Simplify migration and streamline onboarding experience.",
  imageWidth: '310',
  imageHeight: '945',
  mobile1x: dataMigrationMob1x,
  mobile2x: dataMigrationMob2x,
  desktop1x: dataMigrationDesk1x,
  desktop2x: dataMigrationDesk2x,
}

export default function Migration() {
  const breadcrumbs = getSolutionsBreadcrumbs(pageData.title)

  return (
    <DefaultPageLayout className={classes.page}>
      <SolutionHeadMetatag pageData={pageData} />
      <Container>
        <BreadcrumbsNavigation
          breadcrumbs={breadcrumbs}
          className={classes.breadcrumbs}
        />
      </Container>
      <Container grid>
        <SolutionHero {...pageHeroData} />
        <SolutionHIL
          titles={[
            { text: 'Select another SaaS to import data from' },
            { text: 'Select type(s) of data to be imported' },
            {
              text: 'Configure field mappings (or use defaults)',
              optional: true,
            },
            { text: 'Launch import and monitor status' },
          ]}
        >
          <AppsGrid />
          <img
            srcSet={`${dataImport1x.src} 1x, ${dataImport2x.src} 2x`}
            src={dataImport1x.src}
            alt='Select type(s) of data to be imported'
            width={522}
            height={295}
            loading='lazy'
          />
          <img
            srcSet={`${fieldMappings1x.src} 1x, ${fieldMappings2x.src} 2x`}
            src={fieldMappings1x.src}
            alt='Configure field mappings'
            width={522}
            height={314}
            loading='lazy'
          />
          <MonitorStatus />
        </SolutionHIL>
        <SolutionHowItWorks
          steps={[
            'Select apps you want your customers to import data from',
            'Configure migration flows',
            'Build onboarding UI to connect external app on behalf of your customer',
            'Run import flows and store data in your system',
          ]}
        />
        <SolutionCompanies />
        <SolutionInfrastructure />
        <BestSupport
          isSolutionsSection
          subtitle={
            <>
              Integrations are hard and messy. <br /> Our success team will help
              you every step of the way.
            </>
          }
          className={classes.support}
        />
      </Container>
    </DefaultPageLayout>
  )
}
